import {DataPlugin, DisplayData, DisplayDataWidget} from "../../data";
import {CompassDisplay, SimpleCompassOneLineDisplay, SimpleCompassWidget } from "./simple.compass.display";

export const CompassDataName = 'compass';
export type TargetAudience = "everyone" | "GROUPGERMANY" | "GROUPExternal" | "GROUPInternal" | "GROUP";
export type CompassData = {
    id: number;
    url: string;
    category: string;
    documentTypePath: string;
    createDate: string;
    lastModifiedDate: string;
    published: boolean;
    type: string;
    contentType: string;
    title: string;
    description: string;
    pageContent: string;
    targetAudiences: TargetAudience;
    authorEmail: string;
    authorDisplayName: string;
    index: string;
    companyIdTags: string[];
    companyTags: string[];
    categoryTags: string[];
}

export function CompassDataPlugin(
    DisplayData: DisplayData<CompassData> = CompassDisplay,
    DisplayDataOneLine: DisplayData<CompassData> = SimpleCompassOneLineDisplay,
    DisplayDataWidget: DisplayDataWidget<CompassData> = SimpleCompassWidget): DataPlugin<CompassData> {
    return {
        plugin: 'data',
        name: 'compass',
        DisplayData,
        DisplayDataOneLine,
        DisplayDataWidget,
        idFrom: data => `${data.index}.${data.id}`
    };
}